import { TimeEntryStatusResponse } from './timeEntryStatusResponse' // adjust path as needed

/**
 * Extends TimeEntryStatusResponse to include shift record flag.
 */
export class TimeEntryClockOutResponse extends TimeEntryStatusResponse {
  /**
   * Creates an instance of TimeEntryClockOutResponse.
   * @param {Object} params - The parameters for initializing the model.
   * @param {boolean} params.isShiftRecordEnabled - Indicates if shift record is enabled.
   */
  constructor({ isShiftRecordEnabled = false, ...restParams } = {}) {
    super(restParams)

    /**
     * Indicates whether shift record is enabled.
     * @type {boolean}
     */
    this.isShiftRecordEnabled = isShiftRecordEnabled
  }
}
